export const networkViewCheck = { path: '/api/v1/nas_profiles' };

export function searchNases(query) {
  return { path: `nases${query}` };
}

export function getNas(nasId) {
  return {
    path: `nases/${nasId}`,
  };
}

export function createNas(nas) {
  return {
    method: 'POST',
    path: 'nases',
    body: JSON.stringify(nas),
  };
}

export function updateNas(nasId, nas) {
  return {
    method: 'PUT',
    path: `nases/${nasId}`,
    body: JSON.stringify(nas),
  };
}

export function deleteNas(nasId) {
  return {
    method: 'DELETE',
    path: `nases/${nasId}`,
  };
}

export function getNasProfile(nasProfileId) {
  return { path: `nas_profiles/${nasProfileId}` };
}

export function searchNasProfiles(query) {
  return { path: `nas_profiles/search${query}` };
}

export function updateNasProfile(nasProfileId, body) {
  return {
    path: `nas_profiles/${nasProfileId}`,
    method: 'PUT',
    body: JSON.stringify(body),
  };
}

export function deleteNasProfile(nasProfileId) {
  return {
    path: `nas_profiles/${nasProfileId}`,
    method: 'DELETE',
  };
}

export function createNasProfile(body) {
  return {
    path: 'nas_profiles',
    method: 'POST',
    body: JSON.stringify(body),
  };
}

export function resetNasProfilePassword(nasProfileId) {
  return {
    path: `nas_profiles/${nasProfileId}/reset`,
    method: 'POST',
  };
}
